import { render, staticRenderFns } from "./history.vue?vue&type=template&id=79b7f10a&"
import script from "./history.vue?vue&type=script&lang=js&"
export * from "./history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79b7f10a')) {
      api.createRecord('79b7f10a', component.options)
    } else {
      api.reload('79b7f10a', component.options)
    }
    module.hot.accept("./history.vue?vue&type=template&id=79b7f10a&", function () {
      api.rerender('79b7f10a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/baseInformation/WuyeZiyuanManager/house/history.vue"
export default component.exports